import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'

export function uploadTemplateConfigAndGetPwaUrl(tenantId, businessUnitId, offerType, pageConfig) {
  const uri = `${casaApiUrl}/direct-offer/offerProgram`
  return fetch(uri, {
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify({
      tenantId: tenantId,
      businessUnitId: businessUnitId,
      offerType: offerType,
      pageConfig: pageConfig
    }),
    headers: {'Content-Type': 'application/json'}
  })
    .then(r => {
      if (!r.ok) {
        throw Error(r.statusText)
      }
      return r
    })
    .then(r => r.json())
    .catch(err => {
      console.error(err)
      throw err
    })
}

export default {
  uploadTemplateConfigAndGetPwaUrl
}



// WEBPACK FOOTER //
// ./src/services/direct-offer-service.js